module.exports = __webpack_public_path__ + "static/media/card-ginecologia.94782f4c.svg";